export default "__VITE_ASSET__DEvY7JPV__"